import { createContext, RefObject } from "react";

const noop = () => null;

type SearchContextValue = {
  searchInputRef: RefObject<HTMLInputElement | null>;
  focusSearchInput: () => void;
  shouldFocus: boolean;
  setShouldFocus: (autoFocus: boolean) => void;
};

const SearchContext = createContext<SearchContextValue>({
  searchInputRef: { current: null },
  focusSearchInput: noop,
  shouldFocus: false,
  setShouldFocus: noop,
});

export default SearchContext;
